const normalizeRegionNumber = (id) => {
  if (id < 10) return `0${id}`

  return id
}

export default normalizeRegionNumber
